import React, { useEffect, useRef, useState } from 'react'
import { Column } from 'primereact/column'
import UnidadeService from "./unidadeService"
import FormList from 'base/FormList'
import { InputSwitch } from 'primereact/inputswitch'

export default function UnidadeList() {

    const [service] = useState(() => new UnidadeService())
    const toast = useRef(null)
    const searchData = {
        pkName: 'codigo_unid',
        dsName: 'descricao_unid',
        mainField: { name: 'descricao_unid', label: 'Descrição' },
        advFields: [
            { name: 'codigo_unid', label: 'Código', type: 'integer', inputMode: 'numeric' },
            { name: 'descricao_unid', label: 'Descrição', type: 'string', inputMode: 'text' },
            { name: 'sigla_unid', label: 'Sigla', type: 'string', inputMode: 'text' },
            { name: 'eh_conj_unid', label: 'É conjunto', type: 'boolean', component: 'TriStateCheckbox', value: null },
            { name: 'eh_frac_unid', label: 'É fração', type: 'boolean', component: 'TriStateCheckbox', value: null },
        ]
    }

    useEffect(() => {
    }, [service])

    return (
        <FormList service={service} toast={toast} searchData={searchData} showActions={true}>
            <Column field="descricao_unid" sortable header="Descrição"></Column>
            <Column field="sigla_unid" sortable header="Sigla"></Column>
            <Column field="eh_conj_unid" sortable header="É conjunto" body={e => <InputSwitch checked={e.eh_conj_unid === 1}></InputSwitch>}></Column>
            <Column field="eh_frac_unid" sortable header="É fração" body={e => <InputSwitch checked={e.eh_frac_unid === 1}></InputSwitch>}></Column>
        </FormList >
    )
}
